export default {
  creditTitle: {
    id: 'dashboard_others_credit_card_title',
    defaultMessage: 'My Credit',
  },
}
